import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import RefreshIcon from "@mui/icons-material/Refresh";
import useSessionsService from "../../services/SessionsService";
import { LiveStream } from "../../types/LiveStream";

export default function AdminLiveNowPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [liveStreams, setLiveStreams] = useState<LiveStream[] | null>(null);
  const [twitchStreams, setTwitchStreams] = useState<LiveStream[] | null>(null);
  const [youtubeStreams, setYoutubeStreams] = useState<LiveStream[] | null>(
    null
  );

  const { getLiveStreams } = useSessionsService();

  const fetchLiveStreams = () => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      getLiveStreams()
        .then(
          async (res) => {
            setLiveStreams(res);

            // Pull the twitch streams out.
            const twitchStreams = res.filter(
              (stream) => stream.platform.toLowerCase() === "twitch"
            );
            setTwitchStreams(twitchStreams);

            // Pull the youtube streams out.
            const youtubeStreams = res.filter(
              (stream) => stream.platform.toLowerCase() === "youtube"
            );
            setYoutubeStreams(youtubeStreams);
          },
          (error) => {
            console.error("Error fetching live streams:", error);
          }
        )
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error("Error fetching live streams:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getFirstFiveTwitchStreams = () => {
    if (!twitchStreams) return [];
    return twitchStreams.slice(0, 5);
  };

  const getRemainingTwitchStreams = () => {
    if (!twitchStreams) return [];
    return twitchStreams.slice(5);
  };

  const getUrlForStream = (stream: LiveStream) => {
    if (stream.watchUrl && stream.watchUrl.length > 0) return stream.watchUrl;

    switch (stream.platform.toLowerCase()) {
      case "twitch":
        return `https://twitch.tv/${stream.username}`;
      case "youtube":
        return `https://www.youtube.com/results?search_query=${stream.username}`;
      default:
        return "#";
    }
  };

  useEffect(() => {
    fetchLiveStreams();
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <PageTitle>
        <LiveTvIcon /> Live streams now{" "}
        <button onClick={fetchLiveStreams}>
          <RefreshIcon />
        </button>
      </PageTitle>
      {isLoading && <div>Loading...</div>}
      {!isLoading && liveStreams && liveStreams.length == 0 && (
        <p>No live streams available</p>
      )}
      {!isLoading && liveStreams && liveStreams.length > 0 && (
        <>
          <h2 className="text-2xl">
            All streams {liveStreams?.length ?? 0}
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-6 gap-4">
            {liveStreams &&
              liveStreams.map((stream, index) => (
                <a
                  className="text-xl card p-4"
                  key={`stream-${index}`}
                  href={getUrlForStream(stream)}
                  target="_blank"
                >
                  {stream.screenshotDownloadUrl ? (
                    <div className="mb-2">
                    <img
                      src={stream.screenshotDownloadUrl}
                      className="object-contain h-48 w-full"
                      alt={`${stream.username} screenshot`}
                    />
                    </div>
                  ) : null}
                  <b className="block">{stream.username}</b>
                  {stream.title && <i className="block">{stream.title}</i>}
                  <span className="block">{stream.platform}</span>
                </a>
              ))}
          </div>
        </>
      )}
    </div>
  );
}
